import { useGetTimesheetRowsWithAutofills } from '@web/api/timesheet-rows/use-get-timesheet-rows';
import { useMemo } from 'react';

export const useTimesheetSummary = (timesheetId: string | undefined) => {
  const { data: timesheetRows } = useGetTimesheetRowsWithAutofills(
    {
      pathParams: {
        id: timesheetId,
      },
    },
    { enabled: !!timesheetId },
  );
  const result = useMemo(() => {
    let totalHours = 0;
    let totalBillable = 0;
    let totalNonbillable = 0;

    timesheetRows?.map((row) => {
      row.entries?.map((entry) => {
        const duration = Number.parseInt(`${entry.duration || 0}`, 10);
        totalHours += duration;
        if (entry.billable) {
          totalBillable += duration;
        } else {
          totalNonbillable += duration;
        }

        return null;
      });
      return null;
    });

    return {
      total: totalHours,
      billable: totalBillable,
      nonBillable: totalNonbillable,
    };
  }, [timesheetRows]);
  return result;
};
